module.exports = __webpack_public_path__ + "static/media/amm2.5872a627.jpg";